import React from "react";

const LegendBadge = ({ color, label, range }) => {
  const dot = {
    green: "bg-emerald-500",
    orange: "bg-amber-500",
    red: "bg-rose-500",
  }[color] ?? "bg-gray-400";

  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gray-50 border border-gray-200 text-[11px] font-medium text-gray-600">
      <span className={`w-2 h-2 rounded-full flex-shrink-0 ${dot}`} />
      <span>{label}</span>
      <span className="text-gray-400 font-normal">({range})</span>
    </span>
  );
};

export default LegendBadge;
